const C = require("../constants");

const listProductsSale = products_sale => {
    return {
        type: C.PRODUCTS_SALE,
        products_sale
    }
};

const updateQuantity = product_sale => {
    return {
        type: C.PRODUCT_SALE_QUANTITY,
        product_sale
    }
};

const addProduct = product_sale => {
    return {
        type: C.PRODUCT_SALE_ADD,
        product_sale
    }
};

const removeProduct = product_sale => {
    return {
        type: C.PRODUCT_SALE_DELETE,
        product_sale
    }
};

export {
    listProductsSale,
    updateQuantity,
    addProduct,
    removeProduct
};


// WEBPACK FOOTER //
// ./src/actions/ProductsSaleActions.js